<template>
  <SoChip
    :type="active ? SoChipType.SUCCESS : SoChipType.DEFAULT"
    :text="active ? 'Active' : 'Inactive'"
    size="small"
    :data-testid="testid"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import { SoChipType } from "@/types/components/SoChip"

  // Renders the shared Active/Inactive status chip used by both the
  // configurations list and the configuration history tables.
  export default defineComponent({
    components: {
      SoChip,
    },
    props: {
      active: {
        type: Boolean,
        required: true,
      },
      testid: {
        type: String,
        default: undefined,
      },
    },
    data() {
      return {
        SoChipType,
      }
    },
  })
</script>
